import React, { useContext } from 'react';
import { Badge } from '@tencent/tea-component/lib/badge';
import classNames from 'classnames';
export var BuyRegionOptionContext = React.createContext(null);
export function BuyRegionOption(optionProps) {
    var context = useContext(BuyRegionOptionContext);
    var props = optionProps;
    if (context) {
        props = context.inject(props);
    }
    var children = props.children, onClick = props.onClick, selected = props.selected, badge = props.badge, disabled = props.disabled;
    return (React.createElement("button", { className: classNames('tea-btn tea-btn--weak', {
            'is-selected': selected,
            'is-disabled': disabled,
        }), onClick: disabled ? undefined : onClick },
        children,
        badge && React.createElement(Badge, { theme: "warning" }, badge)));
}
//# sourceMappingURL=BuyRegionOption.js.map